var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',[_c('div',[_c('div',{staticClass:"savethumburlpop-backdrop",on:{"click":_vm.onRequestClose}}),_vm._v(" "),_c('div',{ref:"content",staticClass:"savethumburlpop-content",style:(_vm.styleObject)},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }